import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api';

import { HttpHeader } from '../../common';
import { SfccSettings } from '../../site-settings/models';
import { normalizeSFCCLocale } from '../utilities/normalize-sfcc-locale';
import { BasketHttp } from './basket-http';

export const sfccHttp = new BasketHttp();
export const shopHttp = new BasketHttp();
export let sfccSettings: SfccSettings;

export const initializeBasketHttp = async (settings: SfccSettings): Promise<void> => {
  if (!settings) {
    console.error('SFCC settings are not initialized');
    return;
  }
  sfccSettings = settings;

  const headers: Record<string, string | boolean> = {
    [HttpHeader.ClientId]: sfccSettings.shopApiClientId,
  };
  const authToken = await getWebStoreApiClient().onTokenAcquired;
  const sfccBaseUrl = `${sfccSettings.sfccBaseUrl}/${normalizeSFCCLocale(sfccSettings.shopApiLocale || '')}`;

  sfccHttp.initializeHttp(sfccBaseUrl, headers, authToken);
  shopHttp.initializeHttp(sfccSettings.shopApiBaseUrl, headers, authToken);
};
